import { Injectable, signal } from '@angular/core';

/**
 * Centralizes the open/closed state of the mobile menu drawer (TASK-59145
 * Fase 5). The header's hamburger button calls `toggle()` when on mobile;
 * the layout mounts `<app-menu-drawer>` which subscribes to the signal.
 *
 * Lives at the root injector so the header and the drawer can communicate
 * without any DOM relationship — the layout is recreated on every navigation
 * (each feature page declares its own `<app-layout>`), so any state we put
 * on the layout itself would reset to closed mid-drill-down.
 */
@Injectable({ providedIn: 'root' })
export class MenuDrawerService {
  private readonly _isOpen = signal(false);

  /** Read-only signal reflecting the current open state. */
  readonly isOpen = this._isOpen.asReadonly();

  open(): void {
    this._isOpen.set(true);
  }

  close(): void {
    this._isOpen.set(false);
  }

  toggle(): void {
    this._isOpen.update(v => !v);
  }
}
